// 1. Import the extendTheme function
import { extendTheme } from '@chakra-ui/react';
import { colors } from './colors';
import { fonts } from './fonts';
import { global } from './global';
import { buttonStyle } from './components/button';
import { inputStyle } from './components/input';
import { switchStyle } from './components/switch';
import { textAreaStyle } from './components/text_area';

/**
 * Tokens semanticos para o design glassmorphism.
 * Todos resolvem para o valor light — sem dark mode.
 */
const semanticTokens = {
  colors: {
    // Backgrounds
    'glass.app': '#F5F6F6',
    'glass.surface': 'rgba(255, 255, 255, 0.72)',
    'glass.surfaceStrong': 'rgba(255, 255, 255, 0.92)',
    'glass.surfaceMuted': 'rgba(241, 245, 249, 0.6)',
    'glass.accent': 'rgba(27, 136, 245, 0.08)',
    'glass.accentHover': 'rgba(27, 136, 245, 0.14)',

    // Borders
    'glass.border': 'rgba(27, 136, 245, 0.15)',
    'glass.borderSubtle': 'rgba(0, 0, 0, 0.06)',

    // Texto
    'glass.text': '#0F172A',
    'glass.textMuted': '#71717A',
    'glass.textSubtle': '#94A3B8',

    // Brand (azul Indicadores)
    'glass.brand': '#1B88F5',
    'glass.brandSoft': '#DFF3FF',
  },
};

export const theme = extendTheme({
  ...global,
  colors,
  fonts,
  semanticTokens,
  components: {
    Button: buttonStyle,
    Input: inputStyle,
    Textarea: textAreaStyle,
    Switch: switchStyle,
  },
});
